"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.CashbackWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  checked,
  theme
}) => ({
  border: `1px solid ${checked ? theme.palette.text.primary : theme.palette.grey[300]}`,
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(3)
}));
const CashbackWrapper = exports.CashbackWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  '&:empty': {
    display: 'none'
  }
}));
//# sourceMappingURL=styles.js.map